import { createSlice } from '@reduxjs/toolkit'
import { REHYDRATE } from 'redux-persist'

export const initialState = {
    loaded: false,
    value: null,
}

export const nameSlice = createSlice({
    name: 'settings/name',
    initialState,
    reducers: {
        setSiteName: (state, action) => {
            state.value = action.payload
            state.loaded = true
        },
    },
    extraReducers: (builder) => {
        // The persisted `value` is already merged in by redux-persist by the
        // time this runs. Force `loaded` back to false so the fetch-on-mount
        // effect still revalidates against the server instead of trusting
        // the cached value forever - this only avoids the flash of the
        // fallback name before that fetch resolves.
        builder.addCase(REHYDRATE, (state) => {
            state.loaded = false
        })
    },
})

export const { setSiteName } = nameSlice.actions

export default nameSlice.reducer
